export const GARAGE_NETWORK_PAGE_URL = '/garage-networks';
